<template>
  <div class="container-fluid pt-2">

    <!-- HEADER -->
    <div class="row mb-3 align-items-center">
      <div class="col-md-6">
        <h5 class="mb-0 font-weight-bold text-primary">LPOs (Local Purchase Orders)</h5>
      </div>
      <div class="col-md-6 text-right">
        <b-button variant="primary" size="sm" @click="openCreateModal">
          <i class="fa fa-plus"></i> New LPO
        </b-button>
      </div>
    </div>

    <!-- FILTERS -->
    <div class="row mb-3 align-items-end">

      <!-- SEARCH -->
      <div class="col-md-8">
       <div class="form-group">
                            <date-range-picker :auto-apply="autoApply" v-model="dateRange" :ranges="ranges" :opens="datepicker_opens" :append-to-body="append_to_body" class="custom-width-datepicker">
                                <template #input="picker" style="width: 100% !important;">
                                                                    <p v-if="picker.startDate !==null && picker.endDate !==null">{{ formatDate(picker.startDate,'DD-MMM-YYYY') }} - {{ formatDate(picker.endDate,'DD-MMM-YYYY') }}</p>
                                                                    <p v-else><i class="bi bi-calendar-event"></i>  Filter by Date</p>
</template>
                                            </date-range-picker>
                                        </div>
        <!-- <input
          v-model="filters.search"
          type="text"
          class="form-control"
          placeholder="Search by requisition ID or requester"
        /> -->
      </div>

      <!-- STATUS -->
      <div class="col-md-4">
        <div class="form-group">
        <select v-model="filters.status" class="form-control">
          <option value="">All Statuses</option>
          <option value="pending">Pending</option>
          <option value="approved">Approved</option>
          <option value="partially_received">Partly received</option>
          <option value="received">Received</option>
          <option value="rejected">Rejected</option>
        </select>
        </div>
      </div>



    </div>

    <!-- TABLE -->
    <b-table
      :items="items"
      :fields="fields"
      small
      striped
      hover
      responsive
      :busy="loading"
      @row-clicked="openViewModal"
    >
      <template #cell(status)="row">
        <span
          class="badge"
          :class="statusClass(row.item.status)"
        >
          {{ statusLabel(row.item.status) }}
        </span>
      </template>

      <template #cell(created_at)="row">
        {{ formatDate(row.item.created_at) }}
      </template>
    </b-table>

    <!-- PAGINATION -->
    <b-pagination
      v-model="page"
      :total-rows="total"
      :per-page="perPage"
      @change="fetchRequisitions"
      class="mt-2"
    />

    <!-- ================= CREATE MODAL ================= -->
    <b-modal ref="createModal" title="New LPO" size="lg" hide-footer>
      <form @submit.prevent="submitRequisition">

        <div class="form-row">
          <div class="form-group col-md-6">
            <label>Supplier</label>
            <select v-model="form.supplier_id" class="form-control" required>
              <option disabled value="">Select supplier</option>
              <option v-for="s in suppliers" :key="s.id" :value="s.id" class="text-capitalize">{{ s.supplier }}</option>
            </select>
            <small v-if="!suppliers.length" class="text-muted">No suppliers yet — add one under Purchases / Bulk Restock.</small>
          </div>
          <div class="form-group col-md-6">
            <label>Approver</label>
            <select v-model="form.approver_id" class="form-control" required>
              <option disabled value="">Select approver</option>
              <option v-for="u in approvers" :key="u.id" :value="u.id" class="text-capitalize">{{ u.name }}</option>
            </select>
          </div>
        </div>

        <label>Items</label>
        <div v-for="(item, index) in form.items" :key="index" class="form-row align-items-center">
          <div class="form-group col-md-6">
            <select v-model="item.id" class="form-control" required @change="prefillCost(item)">
              <option disabled value="">Product</option>
              <option v-for="p in products" :key="p.id" :value="p.id">{{ p.product }}</option>
            </select>
          </div>
          <div class="form-group col-md-2">
            <input type="number" min="1" v-model.number="item.quantity" class="form-control" placeholder="Qty" required />
          </div>
          <div class="form-group col-md-3">
            <input type="number" min="0" step="0.01" v-model.number="item.unit_cost" class="form-control" placeholder="Unit cost" />
          </div>
          <div class="form-group col-md-1">
            <b-button variant="danger" @click="removeItem(index)">✕</b-button>
          </div>
        </div>

        <div class="d-flex justify-content-between align-items-center mb-3">
          <b-button size="sm" variant="secondary" @click="addItem">+ Add Item</b-button>
          <strong>Total: {{ money(lineTotal(form.items)) }}</strong>
        </div>

        <div class="text-right">
          <b-button variant="secondary" @click="$refs.createModal.hide()">Cancel</b-button>
          <b-button variant="primary" type="submit" :disabled="loading">Submit for approval</b-button>
        </div>

      </form>
    </b-modal>

    <!-- ================= VIEW / APPROVAL MODAL ================= -->
    <b-modal ref="viewModal" size="lg" hide-footer>
      <div v-if="active">

        <h6 class="mb-2">LPO #{{ active.requisition_code }}</h6>
        <p><strong>Supplier:</strong>
          <select v-if="canApprove && active.status === 'pending'" v-model="active.supplier_id" class="form-control d-inline-block w-auto">
            <option :value="null" disabled>Select supplier</option>
            <option v-for="s in suppliers" :key="s.id" :value="s.id" class="text-capitalize">{{ s.supplier }}</option>
          </select>
          <span v-else class="text-capitalize">{{ active.supplier ? active.supplier.supplier : '—' }}</span>
        </p>
        <p><strong>Status:</strong> <span class="badge" :class="statusClass(active.status)">{{ statusLabel(active.status) }}</span></p>
        <p><strong>Requested by:</strong> {{ active.requester.name }}</p>
        <p><strong>Approver:</strong> {{ active.approver.name }}</p>

        <table class="table table-sm table-bordered">
          <thead>
            <tr>
              <th>Product</th>
              <th width="120">Quantity</th>
              <th width="140" class="text-right">Unit cost</th>
              <th width="120" class="text-right">Amount</th>
              <th v-if="isReceivable || active.status === 'received'" width="100" class="text-right">Received</th>
              <th v-if="isReceivable" width="110" class="text-right">Outstanding</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in active.items" :key="item.id">
              <td>{{ item.product.product }}</td>
              <td>
                <input
                  v-if="canApprove && active.status === 'pending'"
                  type="number"
                  min="1"
                  class="form-control"
                  v-model.number="item.quantity"
                />
                <span v-else>{{ item.quantity }}</span>
              </td>
              <td class="text-right">
                <input
                  v-if="canApprove && active.status === 'pending'"
                  type="number"
                  min="0"
                  step="0.01"
                  class="form-control"
                  v-model.number="item.unit_cost"
                />
                <span v-else>{{ money(item.unit_cost) }}</span>
              </td>
              <td class="text-right">{{ item.unit_cost === null || item.unit_cost === '' ? '—' : money(item.quantity * item.unit_cost) }}</td>
              <td v-if="isReceivable || active.status === 'received'" class="text-right">{{ item.received_quantity || 0 }}</td>
              <td v-if="isReceivable" class="text-right" :class="{ 'text-danger': item.outstanding_quantity > 0 }">{{ item.outstanding_quantity }}</td>
            </tr>
          </tbody>
          <tfoot>
            <tr>
              <th colspan="3" class="text-right">Total</th>
              <th class="text-right">{{ money(lineTotal(active.items)) }}</th>
              <th v-if="isReceivable || active.status === 'received'"></th>
              <th v-if="isReceivable"></th>
            </tr>
          </tfoot>
        </table>

        <div v-if="active.purchases && active.purchases.length" class="small text-secondary mb-2">
          Purchases recorded: {{ active.purchases.map(p => p.purchase_order).join(', ') }}
        </div>

        <div v-if="active.rejection_reason" class="alert alert-danger">
          {{ active.rejection_reason }}
        </div>

        <div class="d-flex justify-content-between">
          <b-button
            size="sm"
            variant="outline-secondary"
            @click="downloadPdf(active.id)"
          >
            Download PDF
          </b-button>

          <a v-if="isReceivable" :href="`/bulk-restock?requisition=${active.id}`" class="btn btn-primary btn-sm">
            <i class="bi bi-box-arrow-in-down mr-1"></i>Record purchase (receive stock)
          </a>

          <div v-if="canApprove && active.status === 'pending'">
            <b-button size="sm" variant="danger" @click="rejectPrompt = true">
              Reject
            </b-button>
            <b-button size="sm" variant="primary" @click="approveRequisition">
              Approve
            </b-button>
          </div>
        </div>

        <div v-if="rejectPrompt" class="mt-3">
          <textarea
            v-model="rejectionReason"
            class="form-control"
            placeholder="Rejection reason"
          ></textarea>
          <b-button
            size="sm"
            variant="danger"
            class="mt-2"
            @click="rejectRequisition"
          >
            Confirm Rejection
          </b-button>
        </div>

      </div>
    </b-modal>

  </div>
</template>

<script>
import { downloadFile } from '../../services/pdfDownload';
import DateRangePicker from "vue2-daterange-picker/src/components/DateRangePicker";
import moment from "moment";
import { mapGetters } from "vuex";

export default {
  name: "RequisitionManager",
  components: { DateRangePicker },

  data() {
    return {
      items: [],
      products: [],
      approvers: [],
      suppliers: [],
      active: null,

      page: 1,
      perPage: 20,
      total: 0,
      loading: false,

      dateRange: {
        startDate: null,
        endDate: null
      },
         autoApply: true,
                append_to_body: true,
                datepicker_opens: 'right',
                ranges: false,

      filters: {
        from: null,
        to: null,
        search: "",
        status: ""
      },

      form: {
        approver_id: "",
        supplier_id: "",
        items: [{ id: "", quantity: 1, unit_cost: null }]
      },

      rejectPrompt: false,
      rejectionReason: "",

      fields: [
        { key: "requisition_code", label: "LPO #" },
        { key: "supplier.supplier", label: "Supplier" },
        { key: "requester.name", label: "Requester" },
        { key: "status", label: "Status" },
        { key: "created_at", label: "Date" }
      ]
    };
  },

  computed: {
    ...mapGetters(["userDetails"]),

    isReceivable() {
      return this.active && ['approved', 'partially_received'].includes(this.active.status);
    },
    canApprove() {
      return this.active && this.active.approver_id === this.userDetails.id;
    }
  },

  watch: {
    dateRange: {
      deep: true,
      handler(after) {
        if (after.startDate && after.endDate) {
          this.filters.from = after.startDate.toISOString().split("T")[0];
          this.filters.to   = after.endDate.toISOString().split("T")[0];
        } else {
          this.filters.from = null;
          this.filters.to = null;
        }
        this.fetchRequisitions();
      }
    },
    "filters.search": "fetchRequisitions",
    "filters.status": "fetchRequisitions"
  },

  mounted() {
    this.fetchRequisitions();
    this.fetchSuppliers();
    // Deep link from the approval notification: /requisitions?open=<id>
    const open = new URLSearchParams(window.location.search).get("open");
    if (open) this.openViewModal({ id: open });
  },

  methods: {
    formatDate(d) {
      return moment(d).format("DD-MM-YYYY");
    },

    fetchRequisitions() {
      this.loading = true;
      axios
        .get("/api/requisitions", {
          params: {
            ...this.filters,
            page: this.page
          }
        })
        .then(res => {
          this.items = res.data.data.data || res.data.data;
          this.total = res.data.data?.total || 0;
          this.perPage = res.data.data?.per_page || 20;
        })
        .finally(() => (this.loading = false));
    },

    fetchSuppliers() {
      return axios.get("/api/all-suppliers").then(r => (this.suppliers = r.data || []));
    },

    async openCreateModal() {
      this.form = { approver_id: "", supplier_id: "", items: [{ id: "", quantity: 1, unit_cost: null }] };
      this.$refs.createModal.show();
      if (!this.products.length) {
        axios.get("/api/only-products").then(r => (this.products = Object.values(r.data || {})));
      }
      if (!this.approvers.length) {
        axios.get("/api/employees").then(r => {
          this.approvers = (r.data || []).filter(e => e.users).map(e => ({ id: e.users.id, name: e.first_name || e.users.name }));
        });
      }
    },

    prefillCost(item) {
      const p = this.products.find(x => x.id === item.id);
      if (p) item.unit_cost = p.wholesale_ppu !== null && p.wholesale_ppu !== undefined ? Number(p.wholesale_ppu) : null;
    },

    money(v) {
      if (v === null || v === undefined || v === "") return "—";
      return Number(v).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    },

    lineTotal(items) {
      return (items || []).reduce((t, i) => t + (Number(i.quantity) || 0) * (Number(i.unit_cost) || 0), 0);
    },

    addItem() {
      this.form.items.push({ id: "", quantity: 1, unit_cost: null });
    },

    removeItem(i) {
      if (this.form.items.length > 1) this.form.items.splice(i, 1);
    },

    submitRequisition() {
      this.loading = true;
      axios.post("/api/requisitions", this.form)
        .then(() => {
          this.$refs.createModal.hide();
          this.$toasts.push({ type: "success", message: "LPO sent for approval." });
          this.fetchRequisitions();
        })
        .catch(e => this.$toasts.push({ type: "error", message: e.response?.data?.message || "Could not create the LPO." }))
        .finally(() => (this.loading = false));
    },

    statusClass(status) {
      return {
        pending: 'badge-secondary', approved: 'badge-primary', partially_received: 'badge-dark',
        received: 'badge-primary', rejected: 'badge-danger',
      }[status] || 'badge-secondary';
    },
    statusLabel(status) {
      return ({ partially_received: 'PARTLY RECEIVED' }[status] || (status || '').toUpperCase());
    },
    openViewModal(row) {
      axios.get(`/api/requisitions/${row.id}`).then(r => {
        this.active = r.data;
        this.rejectPrompt = false;
        this.$refs.viewModal.show();
      });
    },

    approveRequisition() {
      axios.post(`/api/requisitions/${this.active.id}/approve`, {
        supplier_id: this.active.supplier_id,
        items: this.active.items.map(i => ({ id: i.id, quantity: i.quantity, unit_cost: i.unit_cost }))
      }).then(() => {
        this.$refs.viewModal.hide();
        this.fetchRequisitions();
      }).catch(e => this.$toasts.push({ type: "error", message: e.response?.data?.message || "Could not approve." }));
    },

    rejectRequisition() {
      axios.post(`/api/requisitions/${this.active.id}/reject`, {
        reason: this.rejectionReason
      }).then(() => {
        this.$refs.viewModal.hide();
        this.fetchRequisitions();
      }).catch(e => this.$toasts.push({ type: "error", message: e.response?.data?.message || "Could not reject." }));
    },

    downloadPdf(id) {
      downloadFile(`/api/requisitions/${id}/pdf`, "requisition.pdf")
        .catch(() => this.$toasts.push({ type: "error", message: "Could not download the PDF. Please try again." }));
    }
  }
};
</script>
